import React from 'react';
import DashboardCard from '../shared/DashboardCard';
import CircularProgressWidget from '../shared/CircularProgressWidget';

interface ComplianceScoreWidgetProps {
    completionRate: number;
    completedItems: number;
    totalItems: number;
    loading?: boolean;
}

const ComplianceScoreWidget: React.FC<ComplianceScoreWidgetProps> = ({
    completionRate,
    completedItems,
    totalItems,
    loading,
}) => (
    <DashboardCard
        title="Compliance Score"
        loading={loading}
    >
        <CircularProgressWidget
            value={completionRate}
            size={130}
            strokeWidth={11}
            completed={completedItems}
            total={totalItems}
        />
    </DashboardCard>
);

export default ComplianceScoreWidget;
